<!--租房界面-->
<template>
    <div class="fin-panel">
        <van-nav-bar title="房屋出租">
        </van-nav-bar>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了..."
                loading-text="加载中,请稍后"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad"
        >
            <div v-for="item in rentList">
                <van-row v-if="item.title">
                    <van-divider content-position="left" :style="{ color: '#969799', borderColor: '#969799', padding: '0 16px' }">{{item.title}}</van-divider>
                </van-row>
                <van-row v-if="item.rentDesc">{{item.rentDesc}}</van-row>
                <van-row v-if="item.imgUrl">
                    <van-col><van-image :src="item.imgUrl"/></van-col>
                </van-row>
            </div>
        </van-list>

     </div>
</template>
<script>
    import * as MyApi from '../../api/URLApiAddr.js'
    export default {
        name: "Rent.vue",
        data(){
            return {
                error: false,
                loading: false,
                finished: false,
                rentList:[]
            }
        },
        methods: {
            onLoad() {
                this.loading = true;
                this.$axios.post(MyApi.QRY_RENT_LIST/*,options*/)
                    .then((response) =>  {
                        debugger
                        let code = response.code;
                        if(code == '200'){
                            let data = response.data
                            if(data.length >0){
                                //ths.list = data.records
                                this.rentList = data
                                this.finished = true
                            }
                        }
                        this.loading = false;
                    })
                    .catch((err) =>{
                        this.$toast.fail("数据初始化异常"+err);
                    })

            },
            getImgUrl(img_url){
                return img_url;
            }
        }
    }

</script>

<style scoped>
    .fin-panel {
        min-width: 120px;
        font-size: 14px;
        line-height: 36px;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 60px;
    }
</style>
